import { Link } from 'react-router-dom';
import { Header } from "antd/lib/layout/layout";
import Menu from 'antd/lib/menu';
import Logo from '../assets/logo.svg';

export default function Navbar(){
  return(
    <Header style={{ position: 'fixed', zIndex: 1, width: '100%' }}>
      <Menu theme="dark" mode="horizontal" className="leftMenu" defaultSelectedKeys={'home'}  >
        <Link on to="/" className="logo"><img alt="logo" src={Logo} /></Link>
        <Menu.Item key="about" key={'about'} ><Link to="/about">Tentang Kami</Link></Menu.Item>
        {/* <Menu.Item key="FAQ">FAQ</Menu.Item> */}
      </Menu>
    </Header>
  )
}